var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityIllus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.2012,
    y: 0.707031,
    width: 56,
    height: 56,
    rx: 12,
    transform: "rotate(15 18.2012 0.707031)",
    fill: "#41A8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_42795_8046)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 56,
    height: 56,
    rx: 12,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 17.5,
    width: 55,
    height: 55,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6673 40.333V37.0663C32.6673 35.7596 32.6673 35.1062 32.413 34.607C32.1893 34.168 31.8323 33.811 31.3933 33.5873C30.8942 33.333 30.2408 33.333 28.934 33.333H20.0673C18.7605 33.333 18.1071 33.333 17.608 33.5873C17.169 33.811 16.812 34.168 16.5883 34.607C16.334 35.1062 16.334 35.7596 16.334 37.0663V45.933C16.334 47.2398 16.334 47.8932 16.5883 48.3923C16.812 48.8314 17.169 49.1883 17.608 49.412C18.1071 49.6663 18.7605 49.6663 20.0673 49.6663H23.334M28.0007 48.4997L30.334 50.833L35.584 45.583M27.0673 56.6663H35.934C37.2408 56.6663 37.8942 56.6663 38.3933 56.412C38.8323 56.1883 39.1893 55.8314 39.413 55.3923C39.6673 54.8932 39.6673 54.2398 39.6673 52.933V44.0663C39.6673 42.7596 39.6673 42.1062 39.413 41.607C39.1893 41.168 38.8323 40.811 38.3933 40.5873C37.8942 40.333 37.2408 40.333 35.934 40.333H27.0673C25.7605 40.333 25.1071 40.333 24.608 40.5873C24.169 40.811 23.812 41.168 23.5883 41.607C23.334 42.1062 23.334 42.7596 23.334 44.0663V52.933C23.334 54.2398 23.334 54.8932 23.5883 55.3923C23.812 55.8314 24.169 56.1883 24.608 56.412C25.1071 56.6663 25.7605 56.6663 27.0673 56.6663Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_42795_8046",
    x: -16,
    y: 1,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_42795_8046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_42795_8046",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIllus);
export default __webpack_public_path__ + "static/media/activity-illus.c8c577ec5db65814e0cdada9660dcffe.svg";
export { ForwardRef as ReactComponent };